import axios from 'axios';

import pushEvent, { EVENT_NAVIGATION_ITEM_CLICK } from 'pushEvent';

import { getSearchSuggestionsUrlTemplate } from './selectors';

/** this method is used in the orignal method below and in search crutch */
export const composeRequestSearchSuggestions = (suggestionsUrlTemplate) => (value) =>
  axios.get(suggestionsUrlTemplate.replace('{{query}}', encodeURIComponent(value))).then(
    (response) => response.data.products,
    () => [],
  );

export const requestSearchSuggestions = (value) => (_, getState) => {
  const state = getState();
  const suggestionsUrlTemplate = getSearchSuggestionsUrlTemplate(state);
  return composeRequestSearchSuggestions(suggestionsUrlTemplate)(value);
};

export const processNavigationItemClick = (value) => () => {
  try {
    const { name, url, position } = value;
    pushEvent(EVENT_NAVIGATION_ITEM_CLICK, { name, url, position });
  } catch {
    console.warn('no value for processNavigationItemClick');
  }
};
